'use strict';

var supports = require('./supports');
var utils = require('./utils');

/**
 * Возвращает версию Internet Explorer.
 *
 * @returns {string | null}
 */
var ie = null;

/**
 * Возвращает версию iOS.
 *
 * @returns {string | null}
 */
var ios = null;

/**
 * Возвращает версию Android.
 *
 * @returns {string | null}
 */
var android = null;

/**
 * Возвращает версию Windows Phone.
 *
 * @returns {string | null}
 */
var wp = null;

/**
 * @returns {boolean}
 */
var iphone = false;

/**
 * @returns {boolean}
 */
var ipad = false;

/**
 * @returns {boolean}
 */
var other = false;

/**
 * @returns {boolean}
 */
var server = false;

/**
 * Устанавливает изначальные значения,
 * данная функция нужна только для тестирования.
 * @internal
 */
function resetValues() {
    ie = null;
    ios = null;
    android = null;
    wp = null;
    iphone = false;
    ipad = false;
    other = false;
    server = false;
}

/**
 * Очищает классы у HTML элемента.
 * @internal
 */
function clearHTMLClassList() {
    document.documentElement.className = '';
}

/**
 * Устанавливает значения из user-agent.
 */
function setMatchedValues() {
    var match = false;
    var userAgent = window.navigator.userAgent;

    if(/msie|trident/i.test(userAgent)) {
        ie = parseInt(userAgent.split(/msie|rv:/i)[1], 10);
    }

    /* eslint-disable no-cond-assign */
    if(match = userAgent.match(/Windows\sPhone[^\d]*\s([\d.]+)/)) {
        wp = match[1];
    } else if(match = userAgent.match(/Android\s+([\d.]+)/)) {
        android = match[1];
    } else if(match = userAgent.match(/iPhone\sOS\s([\d_]+)/)) {
        ios = match[1].replace(/_/g, '.');
        iphone = true;
    } else if(match = userAgent.match(/iPad.*OS\s([\d_]+)/)) {
        ios = match[1].replace(/_/g, '.');
        ipad = true;
    } else if(match = userAgent.match(/MSIE\s9/)) {
        wp = '7.5';
    } else {
        other = true;
    }
    /* eslint-enable no-cond-assign */
}

/**
 * Возвращает объект с модификаторами.
 *
 * @param {Object} platforms объект поддерживаемых платформ
 * @returns {Object}
 */
function getMods(platforms) {
    return {
        orient: supports.getOrient(),
        platform: supports.getActivePlatform(platforms),
        retina: supports.supportRetina() ? 'yes' : undefined,
        svg: supports.supportSvg() ? 'yes' : 'no',
        inlinesvg: supports.supportInlineSvg() ? 'yes' : 'no',
        'object-fit': supports.supportObjectFit() ? undefined : 'no'
    };
}

function init() {
    // Проверяем, выполняется ли код на сервере – если эта проверка выполняется
    // значит это точно, не браузер
    if(typeof window === 'undefined') {
        return {server: true};
    }

    setMatchedValues();

    var platforms = {ios: ios, android: android, wp: wp, other: other};
    var classNamesList = utils.classNamesBuilder('i-ua', getMods(platforms));
    var classList = document.documentElement.classList;

    classNamesList.forEach(function(className) {
        classList.add(className);
    });

    return {
        ie: ie,
        ios: ios,
        android: android,
        wp: wp,
        iphone: iphone,
        ipad: ipad,
        other: other,
        server: server
    };
}

module.exports = init();

if(process.env.NODE_ENV === 'test') {
    module.exports.init = init;
    module.exports.resetValues = resetValues;
    module.exports.clearHTMLClassList = clearHTMLClassList;
}
